import { Injectable } from '@angular/core';
import { LessonService } from '../../../../services/lesson/lesson.service';
import { LessonProxy } from '../../../../models/proxies/lesson.proxy';
import { ModuleProxy } from '../../../../models/proxies/module.proxy';
import { delay } from '../../../../utils/functions';

type InFlyingValue = Promise<[LessonProxy | null, string?]>
type InFlyingLesson = Map<string, InFlyingValue>;

@Injectable({
  providedIn: 'root',
})
export class LessonDetailService {
  constructor(
    private readonly lessonService: LessonService,
  ) {
  }

  public courseId: string = '';

  public lessons: Map<string, LessonProxy> = new Map<string, LessonProxy>();

  private inFlying: InFlyingLesson = new Map<string, InFlyingValue>();

  public setCourse(courseId?: string): void {
    if (!courseId)
      return;

    if (this.courseId && this.courseId !== courseId)
      this.clearLessons();

    this.courseId = courseId;
  }

  public clearLessons(): void {
    this.lessons.clear();
    this.inFlying.clear();
  }

  public async loadLesson(id: string, courseId?: string): Promise<LessonProxy | null> {
    this.setCourse(courseId);

    if (!id)
      return null;

    const inFlyingLesson = this.inFlying.get(id);

    if (inFlyingLesson) {
      const [lesson] = await inFlyingLesson;
      return lesson;
    }

    const currentLesson = this.lessons.get(id);

    if (!currentLesson) {
      const lessonPromise = this.lessonService.getOneLesson(id);

      this.inFlying.set(id, lessonPromise);
      const [lesson] = await lessonPromise;
      this.inFlying.delete(id);

      if (lesson)
        this.lessons.set(id, lesson);

      return lesson;
    }

    return currentLesson;
  }

  public async preloadLessonsByModules(courseId: string, modules: ModuleProxy[]): Promise<void> {
    if (!courseId) return;

    this.setCourse(courseId);

    for (const module of modules) {
      if (!module.lessons) continue; 
      
      for (const lesson of module.lessons) {
        await this.loadLesson(lesson.id, courseId);
        await delay(500);
      }
    }
  }

}
